// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"36777585","195":"cb7b0539","341":"f412299a","371":"27358325","511":"478de522","551":"10105904","618":"19be7f76","691":"a125543d","696":"83c92731","737":"65ae0d1c","770":"2689d42b","952":"63f278a4","984":"59029c26"}[chunkId] + ".chunk.css";
};